<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
html,
body {
  height: 100%;
}
#app {
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.el-message {
  min-width: auto;
  max-width: 90vw;
  padding: 0.75rem 1.25rem;
  border-radius: 0.375rem;
}

.el-message .el-message__content {
  font-size: 1rem;
  line-height: 1.4;
  white-space: nowrap;
}

.el-message .el-message__icon {
  font-size: 1rem;
  margin-right: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// App.vue?bd651dea